export default {"src":"/_next/static/media/copy_icon.5f457d29.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};